export default class MultipleDynamicList {
    constructor(elm) {
        this.elm = elm;
        var articleContainers = elm.querySelectorAll('[data-articles-container]');

        init();

        function init() {
            if (articleContainers.length) {
                let count = articleContainers[0].dataset.articlesCount;
                let equalHeight = true;
                articleContainers.forEach(item => {
                    if (item.dataset.articlesCount != count) {
                        equalHeight = false;
                    }
                });

                if (equalHeight) {
                    articleContainers.forEach(item => {
                        item.style.height = '100%';
                    });
                }
            }            
        }
    }
}
